import { Edit } from "@mui/icons-material";
import { IconButton, TableRow, Typography, TableCell } from "@mui/material";
import React from "react";

const RowItem = (props) => {
    return <TableRow
        key={props.data.name}
        sx={{ 
            // '&:last-child td, &:last-child th': { border: 0 } 
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            "td": {
                padding: "unset !important"
            },
        }}
        className="table-body-row"
    >
        <TableCell scope="row">
            <div
                className={
                    props.data.modified === true
                        ? "card-flag"
                        : "card-flag-hide"
                }
            >
                <div className="tri-flag" />
            </div>
            <div className="cell-container">
                <Typography>{props.data.normalized}</Typography>
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                <Typography>{props.data.key}</Typography>
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                <Typography>{props.data.value}</Typography>
            </div>
        </TableCell>
        <TableCell align='center'>
                <IconButton>
                    <Edit className='icon-review-style' onClick={() => props.handleEdit(props.id)} />
                </IconButton>
        </TableCell>
    </TableRow>
}

export default RowItem;